import { render, staticRenderFns } from "./requirementAdd.vue?vue&type=template&id=7bdfa906&scoped=true"
import script from "./requirementAdd.vue?vue&type=script&lang=js"
export * from "./requirementAdd.vue?vue&type=script&lang=js"
import style0 from "./requirementAdd.vue?vue&type=style&index=0&id=7bdfa906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdfa906",
  null
  
)

export default component.exports